import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import Add from '../components/Add';
import { addOwnerItem } from '../actions';
import withActiveUserIdAndType from '../../../../common/hoc/withActiveUserIdAndType';
import { getUserUrlPrefix } from '../../../../auth/selectors';

const AddContainer = compose(
  withActiveUserIdAndType({ useShopForBarber: true, useBrandForShop: true }),
  connect(
    state => ({
      shop: state.auth.shop,
      baseUrl: `${getUserUrlPrefix(state)}/customers/marketing-leads`,
    }),
    { addOwnerItem },
  ),
  withHandlers({
    onSubmit: props => data => props.addOwnerItem(props.activeId, props.activeType, data),
  }),
);

export default AddContainer(Add);
